import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { trackUxEvent } from '../../../services/uxEvents';
import { INTENTS, readStoredIntent, writeStoredIntent } from '../services/intents';
import './IntentSegment.css';

/**
 * Six flyer cards. Event intents filter the landing list in place via
 * `onPresetCategories`; route intents navigate. Re-tapping the active event
 * intent clears the filter.
 */
const IntentSegment = ({ onPresetCategories }) => {
  const navigate = useNavigate();
  const [activeId, setActiveId] = useState(() => readStoredIntent());

  const handlePick = (intent) => {
    trackUxEvent({ name: 'intent_select', surface: 'landing', type: intent.id });

    if (intent.href) {
      writeStoredIntent(intent.id);
      setActiveId(intent.id);
      navigate(intent.href);
      return;
    }

    const isActive = activeId === intent.id;
    const nextId = isActive ? '' : intent.id;
    writeStoredIntent(nextId);
    setActiveId(nextId);
    onPresetCategories?.(isActive ? [] : intent.eventCategories || []);

    if (!isActive && typeof document !== 'undefined') {
      document.getElementById('events')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="intent-segment" aria-labelledby="intent-segment-heading">
      <div className="intent-segment__intro">
        <p className="intent-segment__kicker pub-mono">One question. Pure discovery.</p>
        <h2 id="intent-segment-heading" className="intent-segment__heading">
          What do you want?
        </h2>
      </div>
      <ul className="intent-segment__grid">
        {INTENTS.map((intent) => {
          const isActive = activeId === intent.id;
          return (
            <li key={intent.id} className="intent-segment__item">
              <button
                type="button"
                className={`intent-card${isActive ? ' is-active' : ''}`}
                aria-pressed={intent.eventCategories ? isActive : undefined}
                onClick={() => handlePick(intent)}
              >
                <span className="intent-card__file pub-mono">File: {intent.title}</span>
                <span className="intent-card__row">
                  <span className="intent-card__title">{intent.title}</span>
                  <span className="intent-card__glyph" aria-hidden="true">
                    {intent.glyph}
                  </span>
                </span>
                <span className="intent-card__tagline pub-mono">{intent.tagline}</span>
              </button>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default IntentSegment;
